<template>
    <select v-model="displayValue" class="form-control" id="periodo_pagamento" >
        <option v-for="sn in data" :value="sn.value">{{sn.name}}</option>
    </select>
</template>

<script>
    export default {
        name: "ComboPeriodoPagamento",
        props: {
            "value": {
                "default": null
            }
        },
        data(){
            return {
                data: [
                    {
                        value: 'MENSAL',
                        name: 'Mensal'
                    },
                    {
                        value: 'BIMESTRE_PAR',
                        name: 'Bimestral em Fev-Abr-Jun-Ago-Out-Dez'
                    },
                    {
                        value: 'BIMESTRE_IMPAR',
                        name: 'Bimestral em Jan-Mar-Mai-Jul-Set-Nov'
                    },
                    {
                        value: 'TRIMESTRE_JANEIRO',
                        name: 'Trimestral em Jan-Abr-Jul-Out'
                    },
                    {
                        value: 'TRIMESTRE_FEVEREIRO',
                        name: 'Trimestral em Fev-Mai-Ago-Nov'
                    },
                    {
                        value: 'TRIMESTRE_MARCO',
                        name: 'Trimestral em Mar-Jun-Set-Dez'
                    },
                    {
                        value: 'SEMESTRAL_JANEIRO_JULHO',
                        name: 'Semestral em Janeiro e Julho'
                    },
                    {
                        value: 'SEMESTRAL_FEVEREIRO_AGOSTO',
                        name: 'Semestral em Fevereiro e Agosto'
                    },
                    {
                        value: 'SEMESTRAL_MARCO_SETEMBRO',
                        name: 'Semestral em Março e Setembro'
                    },
                    {
                        value: 'SEMESTRAL_ABRIL_OUTUBRO',
                        name: 'Semestral em Abril e Outubro'
                    },
                    {
                        value: 'SEMESTRAL_MAIO_NOVEMBRO',
                        name: 'Semestral em Maio e Novembro'
                    },
                    {
                        value: 'SEMESTRAL_JUNHO_DEZEMBRO',
                        name: 'Semestral em Junho e Dezembro'
                    },
                    {
                        value: 'ANUAL_JANEIRO',
                        name: 'Anual em Janeiro'
                    },
                    {
                        value: 'ANUAL_FEVEREIRO',
                        name: 'Anual em Fevereiro'
                    },
                    {
                        value: 'ANUAL_MARCO',
                        name: 'Anual em Março'
                    },
                    {
                        value: 'ANUAL_ABRIL',
                        name: 'Anual em Abril'
                    },
                    {
                        value: 'ANUAL_MAIO',
                        name: 'Anual em Maio'
                    },
                    {
                        value: 'ANUAL_JUNHO',
                        name: 'Anual em Junho'
                    },
                    {
                        value: 'ANUAL_JULHO',
                        name: 'Anual em Julho'
                    },
                    {
                        value: 'ANUAL_AGOSTO',
                        name: 'Anual em Agosto'
                    },
                    {
                        value: 'ANUAL_SETEMBRO',
                        name: 'Anual em Setembro'
                    },
                    {
                        value: 'ANUAL_OUTUBRO',
                        name: 'Anual em Outubro'
                    },
                    {
                        value: 'ANUAL_NOVEMBRO',
                        name: 'Anual em Novembro'
                    },
                    {
                        value: 'ANUAL_DEZEMBRO',
                        name: 'Anual em Dezembro'
                    },
                ],
            };
        },
        computed: {
            displayValue: {
                get() {
                    return this.value;
                },
                set(modifiedValue) {
                    this.$emit("input", modifiedValue);
                }
            }
        }
    }
</script>
